import PropTypes from 'prop-types'

const target = ({ id }) => {
  const tab = document.getElementById(`product-details-tab-container-tab-${id}`)
  const collapse = document.querySelector(`.collapse-panel-${id}`)

  return tab || (collapse.ariaExpanded === 'false' ? collapse : null)
}

const ScrollToComponent = ({
  hasCaret,
  id,
  isEmphasizedColor,
  title
}) => {
  const handleClick = () => target({ id })?.click()

  const classNames = [
    isEmphasizedColor ? 'vst-btn--large vst-btn--orange-outline' : ''
  ].join(' ').trim()

  return (
    <a
      className={classNames}
      href={`#scroll-target-${id}`}
      onClick={handleClick}
    >
      {title}
      <If condition={hasCaret}>
        <img alt='' src={require('./caret-blue.svg')} />
      </If>
    </a>
  )
}

export default ScrollToComponent

ScrollToComponent.propTypes = {
  hasCaret: PropTypes.bool,
  id: PropTypes.string,
  isEmphasizedColor: PropTypes.bool,
  title: PropTypes.string.isRequired
}
